<template>
  <div>
    <PageAllow controller="Campaigns" :action="allowPermission" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
              Type == 101
                ? $t("Campaigns.activities.type1")
                : Type == 102
                ? $t("Campaigns.activities.type2")
                : Type == 103
                ? $t("Campaigns.activities.type3")
                : Type == 104
                ? $t("Campaigns.activities.type4")
                : Type == 105
                ? $t("Campaigns.activities.type5")
                : Type == 106
                ? $t("Campaigns.activities.type6")
                : Type == 107
                ? $t("Campaigns.activities.type7")
                : Type == 108
                ? $t("Campaigns.activities.type8")
                : Type == 109
                ? $t("Campaigns.activities.type9")
                : "",
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="$router.push('/campaign')"
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("Campaigns.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-row align="center" class="ma-0 bgGreen" style="height: 45px">
          <span class="mx-7 subtitle-2 font-weight-bold">
            {{
              Type == 101
                ? $t("Campaigns.activities.description1")
                : Type == 102
                ? $t("Campaigns.activities.description2")
                : Type == 103
                ? $t("Campaigns.activities.description3")
                : Type == 104
                ? $t("Campaigns.activities.description4")
                : Type == 105
                ? $t("Campaigns.activities.description5")
                : Type == 106
                ? $t("Campaigns.activities.description6")
                : Type == 107
                ? $t("Campaigns.activities.description7")
                : Type == 108
                ? $t("Campaigns.activities.description8")
                : Type == 109
                ? $t("Campaigns.activities.description9")
                : ""
            }}
          </span>
        </v-row>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="observer">
              <!-- 活动名称 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Campaigns.Fields.name") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Campaigns.Fields.name')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="campaign.name"
                      :error-messages="errors"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ campaign.name }}
                </v-col>
              </v-row>
              <!-- 活动描述 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Campaigns.Fields.description") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Campaigns.Fields.description')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="campaign.description"
                      :error-messages="errors"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ campaign.description }}
                </v-col>
              </v-row>
              <!-- 活动时间 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Campaigns.Fields.date") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-row>
                    <v-col cols="5" md="4">
                      <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('Campaigns.Fields.date_from')"
                        rules="required"
                      >
                        <SearcherDatetime
                          class="my-n2"
                          v-model="campaign.date_from"
                          type="date"
                          single-line
                          dense
                          hide-details
                          hide-icon
                          disabledBeforeToday
                          required
                          :errors="errors"
                          readonly
                        >
                          <template v-slot:message="{ key, message }">
                            <div :class="key == 0 ? 'danger--text' : ''">
                              {{ message }}
                            </div>
                          </template>
                        </SearcherDatetime>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="1" class="text-center">~</v-col>
                    <v-col cols="5" md="4">
                      <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('Campaigns.Fields.date_to')"
                        rules="required"
                      >
                        <SearcherDatetime
                          class="my-n2"
                          v-model="campaign.date_to"
                          type="date"
                          single-line
                          dense
                          hide-details
                          hide-icon
                          disabledBeforeToday
                          required
                          :errors="errors"
                          readonly
                        >
                          <template v-slot:message="{ key, message }">
                            <div :class="key == 0 ? 'danger--text' : ''">
                              {{ message }}
                            </div>
                          </template>
                        </SearcherDatetime>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ campaign.date_from | formatDate }}
                  ~
                  {{ campaign.date_to | formatDate }}
                </v-col>
              </v-row>
              <!-- 活动范围 -->
              <v-row align="center">
                <v-col cols="12" md="8" style="margin-left: 14rem">
                  <v-expansion-panels v-model="panels" multiple accordion>
                    <v-expansion-panel>
                      <v-expansion-panel-header class="py-0">
                        {{ $t("Campaigns.Fields.districts") + $t("Global.colon") }}
                        <br />
                        <span v-if="savable">
                          <v-btn
                            color="primary"
                            class="my-1 mr-3"
                            x-small
                            outlined
                            @click="districts_dialog = true"
                            v-if="district_type == 2"
                          >
                            {{ $t("CRUD.chooseInfo", [$t("Campaigns.districts")]) }}
                          </v-btn>
                          <v-btn
                            color="primary"
                            class="my-1 mr-3"
                            x-small
                            outlined
                            @click="shops_dialog = true"
                            v-if="district_type == 3"
                          >
                            {{ $t("CRUD.chooseInfo", [$t("Campaigns.shops")]) }}
                          </v-btn>
                          <!-- <br />
                          <span class="text-caption">
                            {{ $t("MaterialOrderRule.Fields.districts_hint") }}
                          </span> -->
                        </span>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row class="pl-3" v-if="savable">
                          <v-radio-group row v-model="district_type">
                            <v-radio
                              v-for="stat in districtsTypeItems"
                              class="mt-n2"
                              :key="stat.value"
                              :label="`${stat.text}`"
                              :value="stat.value"
                            ></v-radio>
                          </v-radio-group>
                        </v-row>
                        <span v-else>
                          {{ district_type | districtsTypesText }}
                        </span>
                        <v-data-table
                          :headers="districtHeaders"
                          :items="districts"
                          :loading="districtsLoading"
                          multi-sort
                          class="elevation-1 px-4 pt-2"
                          disable-pagination
                          hide-default-footer
                          fixed-header
                          v-if="district_type == 2"
                        >
                          <template v-slot:header.actions="{ header }">
                            {{ header.text }}
                            <v-icon x-small>fa-sliders-h</v-icon>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-btn
                              small
                              text
                              class="danger--text pa-0"
                              @click="
                                districts.splice(
                                  districts.findIndex(
                                    (district) => district.id == item.id
                                  ),
                                  1
                                )
                              "
                            ><v-icon>fa-times</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                        <v-data-table
                          :headers="shopHeaders"
                          :items="shops"
                          multi-sort
                          class="elevation-1 px-4 pt-2"
                          disable-pagination
                          hide-default-footer
                          fixed-header
                          v-if="district_type == 3"
                        >
                          <template v-slot:header.actions="{ header }">
                            {{ header.text }}
                            <v-icon x-small>fa-sliders-h</v-icon>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-btn
                              small
                              text
                              class="danger--text pa-0"
                              @click="
                                shops.splice(
                                  shops.findIndex((shop) => shop.id == item.id),
                                  1
                                )
                              "
                            >
                              <v-icon>fa-times</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
              <!-- 分账类型 -->
              <v-row
                v-if="
                  settings &&
                  settings.sub_account_enable == 1 &&
                  settings.sub_account_split_type == 0 &&
                  (Type == 102 || Type == 108)
                "
              >
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialCoupons.Fields.sub_account_type") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-row class="pa-3 pt-1">
                    <SearcherSubAccountType
                      v-model="sub_account_type"
                      noLabel
                      dense
                    ></SearcherSubAccountType>
                  </v-row>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ campaign ? campaign.sub_account_type_name : "" }}
                </v-col>
              </v-row>
              <!-- 启用自动叠加 -->
              <v-row align="center" v-if="Type == 101 || Type == 107 || Type == 108">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Campaigns.Fields.loop_flg") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-checkbox
                    v-model="loopFlg"
                    :true-value="1"
                    :false-value="0"
                    persistent-hint
                    small
                  ></v-checkbox>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{
                    loopFlg == 1
                      ? $t("Campaigns.Fields.ladder_on")
                      : $t("Campaigns.Fields.ladder_off")
                  }}
                </v-col>
              </v-row>
              <!-- 启用阶梯促销 -->
              <v-row
                align="center"
                v-if="
                  (loopFlg == 0 && (Type == 101 || Type == 107 || Type == 108)) ||
                  (Type != 101 && Type != 107 && Type != 108)
                "
              >
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Campaigns.Fields.ladder_flg") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-checkbox
                    v-model="ladderFlg"
                    :true-value="1"
                    :false-value="0"
                    persistent-hint
                    small
                  ></v-checkbox>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{
                    ladderFlg == 1
                      ? $t("Campaigns.Fields.ladder_on")
                      : $t("Campaigns.Fields.ladder_off")
                  }}
                </v-col>
              </v-row>
              <!-- 活动规则 -->
              <v-row align="center">
                <v-col cols="12" md="8" style="margin-left: 14rem">
                  <v-expansion-panels v-model="panels_two" multiple accordion>
                    <v-expansion-panel>
                      <v-expansion-panel-header class="py-0">
                        {{ $t("Campaigns.Fields.conditions") + $t("Global.colon") }}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row class="pl-3" v-if="savable">
                          <v-radio-group row v-model="material_type">
                            <v-radio
                              v-for="stat in materialsTypeItems"
                              class="mt-n2"
                              :key="stat.value"
                              :label="`${stat.text}`"
                              :value="stat.value"
                            ></v-radio>
                          </v-radio-group>
                        </v-row>
                        <span v-else>
                          {{ material_type | materialsTypesText }}
                        </span>
                        <div class="mt-2" v-if="material_type == 3">
                          <!-- 选择商品 -->
                          <v-btn
                            v-if="savable"
                            color="primary"
                            class="my-1 mr-3"
                            small
                            outlined
                            @click="materials_dialog = true"
                          >
                            {{ $t("CRUD.chooseInfo", [$t("Campaigns.Fields.materials")]) }}
                          </v-btn>
                          <br />
                          <v-data-table
                            :headers="materialHeaders"
                            :items="materialItems"
                            :loading="materialsLoading"
                            multi-sort
                            class="elevation-1 px-4 pt-2"
                            disable-pagination
                            hide-default-footer
                            fixed-header
                          >
                            <template v-slot:header.actions="{ header }">
                              {{ header.text }}
                              <v-icon x-small>fa-sliders-h</v-icon>
                            </template>
                            <template v-slot:item.Description="{ item }">
                              <span>{{ item.material_name }}</span>
                              <br />
                              <span class="caption secondary--text">
                                {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                                <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                                  {{ item.standard_name.slice(0, 12) + "......" }}
                                </span>
                                <span v-else>
                                  {{ item.standard_name }}
                                </span>
                              </span>
                            </template>
                            <template v-slot:item.actions="{ item }">
                              <!-- 删除商品按钮 -->
                              <v-btn
                                small
                                text
                                class="danger--text pa-0"
                                @click="
                                  materials.splice(
                                    materials.findIndex(
                                      (material) => material.id == item.id
                                    ),
                                    1
                                  )
                                "
                              >
                                <v-icon>fa-times</v-icon>
                              </v-btn>
                            </template>
                          </v-data-table>
                        </div>
                        <div class="mt-2" v-if="material_type == 2">
                          <!-- 选择分类 -->
                          <v-btn
                            v-if="savable"
                            color="primary"
                            class="my-1 mr-3"
                            small
                            outlined
                            @click="category_dialog = true"
                          >
                            {{ $t("CRUD.chooseInfo", [$t("Campaigns.category")]) }}
                          </v-btn>
                          <br />
                          <v-data-table
                            :headers="categoryHeaders"
                            :items="categories"
                            multi-sort
                            class="elevation-1 px-4 pt-2"
                            disable-pagination
                            hide-default-footer
                            fixed-header
                          >
                            <template v-slot:header.actions="{ header }">
                              {{ header.text }}
                              <v-icon x-small>fa-sliders-h</v-icon>
                            </template>
                            <template v-slot:item.actions="{ item }">
                              <!-- 删除商品按钮 -->
                              <v-btn
                                small
                                text
                                class="danger--text pa-0"
                                @click="
                                  categories.splice(
                                    categories.findIndex(
                                      (category) => category.id == item.id
                                    ),
                                    1
                                  )
                                "
                              >
                                <v-icon>fa-times</v-icon>
                              </v-btn>
                            </template>
                          </v-data-table>
                        </div>
                        <div class="mt-3">
                          <v-data-table
                            :headers="rulerTypeHeaders"
                            :items="rulerTypeItems"
                            multi-sort
                            class="elevation-1 px-4 pt-2"
                            disable-pagination
                            hide-default-footer
                            fixed-header
                          >
                            <template v-slot:header.actions="{ header }">
                              {{ header.text }}
                              <v-icon x-small>fa-sliders-h</v-icon>
                            </template>
                            <template v-slot:item.actions="{ index }">
                              <v-btn
                                v-if="index != 0"
                                small
                                text
                                class="danger--text pa-0"
                                @click="
                                  Type == 101
                                    ? type_one.splice(index, 1)
                                    : Type == 102
                                    ? type_two.splice(index, 1)
                                    : Type == 103
                                    ? type_three.splice(index, 1)
                                    : Type == 104
                                    ? type_four.splice(index, 1)
                                    : Type == 105
                                    ? type_five.splice(index, 1)
                                    : Type == 106
                                    ? type_six.splice(index, 1)
                                    : Type == 107
                                    ? type_seven.splice(index, 1)
                                    : Type == 108
                                    ? type_eight.splice(index, 1)
                                    : Type == 109
                                    ? type_nine.splice(index, 1)
                                    : type_one.splice(index, 1)
                                "
                              >
                                <v-icon>fa-times</v-icon>
                              </v-btn>
                            </template>
                            <template v-slot:item.step="{ index }">
                              {{ index + 1 }}
                            </template>
                            <template v-slot:item.present_num="{ item }">
                              <NumberInput
                                v-if="savable"
                                v-model="item.present_num"
                                dense
                              />
                              <span v-else>{{ item.present_num }}</span>
                            </template>
                            <template v-slot:item.present_material="{ item, index }">
                              <span v-if="savable">
                                <span
                                  v-if="
                                    item.present_material
                                      ? Object.keys(item.present_material).length
                                      : false
                                  "
                                >
                                  <a
                                    @click="
                                      selectMaterialDialog = true;
                                      currentIndex = index;
                                    "
                                  >{{
                                    $t(
                                      settings
                                        ? settings.material_name_display_type == 4
                                          ? "Material.nameWithCodeAndStandard"
                                          : settings.material_name_display_type == 3
                                          ? "Material.materialNameWithCodeAndStandard"
                                          : settings.material_name_display_type == 2
                                          ? "Material.materialNameWithCode"
                                          : "Material.materialName"
                                        : "Material.materialName",
                                      [
                                        item.present_material
                                          ? item.present_material.material_code
                                          : "",
                                        item.present_material.material_name,
                                        item.present_material.standard_name,
                                      ]
                                    )}}
                                  </a>
                                </span>
                                <span v-else>
                                  <a
                                    @click="
                                      selectMaterialDialog = true;
                                      currentIndex = index;
                                    "
                                  >
                                    {{ $t("Campaigns.Fields.chooseMaterial") }}
                                  </a>
                                </span>
                              </span>
                              <span v-else>
                                <span v-if="item.present_material">
                                  {{
                                    $t(
                                      settings
                                        ? settings.material_name_display_type == 4
                                          ? "Material.nameWithCodeAndStandard"
                                          : settings.material_name_display_type == 3
                                          ? "Material.materialNameWithCodeAndStandard"
                                          : settings.material_name_display_type == 2
                                          ? "Material.materialNameWithCode"
                                          : "Material.materialName"
                                        : "Material.materialName",
                                      [
                                        item.present_material.material_code,
                                        item.present_material.material_name,
                                        item.present_material.standard_name,
                                      ]
                                    )
                                  }}
                                </span>
                              </span>
                            </template>
                            <template v-slot:item.material_num="{ item }">
                              <NumberInput
                                v-if="savable"
                                v-model="item.material_num"
                                dense
                              />
                              <span v-else>{{ item.material_num }}</span>
                            </template>
                            <template v-slot:item.material_price="{ item }">
                              <v-text-field
                                v-if="savable && Type == 108"
                                v-model="item.material_price"
                                single-line
                                dense
                                type="number"
                                min="0"
                                :prefix="$t('Global.money')"
                                style="max-width: 80px; margin-left: auto"
                                @blur="
                                  item.material_price = $numberFormatter.formatMoney(
                                    item.material_price
                                  )
                                "
                              />
                              <v-text-field
                                v-else-if="savable && Type != 108"
                                v-model="item.material_price"
                                single-line
                                dense
                                hide-details
                                type="number"
                                min="0"
                                :prefix="$t('Global.money')"
                                style="max-width: 80px; margin-left: auto"
                                @blur="
                                  item.material_price = $numberFormatter.formatMoney(
                                    item.material_price
                                  )
                                "
                              />
                              <span v-else-if="!savable">
                                {{ $t("Global.money") }}{{ item.material_price }}
                              </span>
                            </template>
                            <template v-slot:item.order_price="{ item }">
                              <v-text-field
                                v-if="savable"
                                v-model="item.order_price"
                                single-line
                                dense
                                hide-details
                                type="number"
                                min="0"
                                :prefix="$t('Global.money')"
                                style="max-width: 80px; margin-left: auto"
                                @blur="
                                  item.order_price = $numberFormatter.formatMoney(
                                    item.order_price
                                  )
                                "
                              />
                              <span v-else>
                                {{ $t("Global.money") }}{{ item.order_price }}
                              </span>
                            </template>
                            <template v-slot:item.price_cut="{ item }">
                              <ValidationProvider
                                v-if="savable && Type == 108"
                                v-slot="{ errors }"
                                :name="$t('Campaigns.Fields.price_cut')"
                                :rules="{
                                  max_value: {
                                    max: item.material_price
                                      ? item.material_price
                                      : 0,
                                  },
                                  min_value: { min: 0.01 },
                                  required: { required: true },
                                }"
                              >
                                <v-text-field
                                  v-model="item.price_cut"
                                  single-line
                                  dense
                                  type="number"
                                  min="0"
                                  :hide-details="errors ? false : true"
                                  :prefix="$t('Global.money')"
                                  style="max-width: 80px; margin-left: auto"
                                  :error-messages="errors"
                                  @blur="
                                    item.price_cut = $numberFormatter.formatMoney(
                                      item.price_cut
                                    )
                                  "
                                />
                              </ValidationProvider>
                              <v-text-field
                                v-else-if="savable && Type != 108"
                                v-model="item.price_cut"
                                single-line
                                dense
                                hide-details
                                type="number"
                                min="0"
                                :prefix="$t('Global.money')"
                                style="max-width: 80px; margin-left: auto"
                                @blur="
                                  item.price_cut = $numberFormatter.formatMoney(
                                    item.price_cut
                                  )
                                "
                              />
                              <span v-else-if="!savable">
                                {{ $t("Global.money") }}{{ item.price_cut }}
                              </span>
                            </template>
                            <template v-slot:item.material_cut="{ item }">
                              <v-text-field
                                v-if="savable"
                                single-line
                                v-model="item.material_cut"
                                type="number"
                                min="0"
                                @blur="
                                  item.material_cut = $numberFormatter.formatTwoDot(
                                    item.material_cut,
                                    true
                                  )
                                "
                                :suffix="$t('Global.rate')"
                              />
                              <span v-else>
                                {{ item.material_cut }} {{ $t("Global.rate") }}
                              </span>
                            </template>
                          </v-data-table>
                          <span v-if="savable">
                            <br />
                            <v-btn
                              v-if="ladderFlg == 1"
                              color="primary"
                              class="my-1 mr-3"
                              outlined
                              @click="addExpressDetail()"
                            >
                              {{ $t("Campaigns.Fields.add_detail") }}
                            </v-btn>
                          </span>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="$router.push('/campaign')"
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backToList", [$t("Campaigns.ObjectName")]) }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  isView &&
                  !campaign.cancel_flg &&
                  campaign.status != 2 &&
                  campaign.status != 1
                "
              >
                <v-btn
                  color="accent"
                  block
                  :disabled="loading && !campaign.id"
                  @click="toEdit = true"
                >
                  <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                  {{ $t("CRUD.editInfo", [$t("Campaigns.ObjectName")]) }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-else-if="
                  !campaign.cancel_flg &&
                  campaign.status != 2 &&
                  campaign.status != 1
                "
              >
                <v-btn
                  color="success"
                  block
                  :disabled="loading"
                  @click="submit()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("Campaigns.save") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
        <v-card class="mt-4" v-if="!isNew">
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-row dense>
                  <span class="text-button">{{
                    $t("Campaigns.Fields.status")
                  }}</span>
                  <v-spacer></v-spacer>
                  <v-chip
                    small
                    label
                    :color="campaign.status | CampaignsColor"
                    :text-color="campaign.status | CampaignsTextColor"
                    >{{ campaign.status | CampaignsText }}
                  </v-chip>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-divider />
              </v-col>
              <v-col cols="12">
                <v-row dense>
                  <span class="text-button">{{
                    $t("Campaigns.Fields.order_count")
                  }}</span>
                  <v-spacer></v-spacer>
                  <v-chip small label color="orange" text-color="white"
                    >{{ campaign.order_cnt }}
                  </v-chip>
                </v-row>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
    <DialogDistricts
      v-model="districts_dialog"
      :districtSelected="districts"
      @confirm="districts = $event"
    />
    <DialogShops
      v-model="shops_dialog"
      :shopSelectedId="shops ? shops.map((e) => {return e.id;}) : []"
      @add="addShop($event)"
      @confirm="shops = $event"
    />
    <DialogCategories
      v-model="category_dialog"
      :categorySelected="categories"
      @confirm="categories = $event"
    />

    <MaterialsSelectsDialog
      v-model="materials_dialog"
      :materialIds="materialIds"
      @confirm="choosedMaterials = $event"
    />
    <DialogMaterial
      v-model="selectMaterialDialog"
      @confirm="
        selectMaterial = $event;
        selectMaterials();
      "
      isActivity
    />
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Campaigns from "@/api/campaigns";
import Required from "@/components/plugins/Required";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import DialogDistricts from "@/components/plugins/DialogDistricts";
import DialogShops from "@/components/plugins/DialogShops";
import DialogCategories from "@/components/plugins/DialogCategories";
import MaterialsSelectsDialog from "@/components/plugins/MaterialsSelectsDialog";
import DialogMaterial from "@/components/plugins/DialogMaterial";
import NumberInput from "@/components/plugins/NumberInput";
import Consts from "@/consts.js";
import SearcherSubAccountType from "@/components/subAccountSettings/plugins/SearcherSubAccountType";

const defaultTypeOne = [
  {
    material_num: null,
    present_num: null,
  },
];
const defaultTypeTwo = [
  {
    material_num: null,
    material_price: null,
  },
];
const defaultTypeThree = [
  {
    material_num: null,
    material_cut: null,
  },
];
const defaultTypeSeven = [
  {
    material_price: null,
    present_num: null,
  },
];
const defaultTypeEight = [
  {
    material_price: null,
    price_cut: null,
  },
];
const defaultTypeNine = [
  {
    material_price: null,
    material_cut: null,
  },
];
const defaultTypeFour = [
  {
    order_price: null,
    present_num: null,
  },
];
const defaultTypefive = [
  {
    order_price: null,
    price_cut: null,
  },
];
const defaultTypesix = [
  {
    order_price: null,
    price_cut: null,
  },
];
export default {
  components: {
    PageAllow,
    Breadcrumbs,
    ValidationObserver,
    ValidationProvider,
    Required,
    SearcherDatetime,
    DialogDistricts,
    MaterialsSelectsDialog,
    DialogMaterial,
    NumberInput,
    DialogShops,
    DialogCategories,
    SearcherSubAccountType,
  },

  computed: {
    allowPermission() {
      return "view" || "add" || "edit";
    },
    items() {
      var item = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.materialManagement"),
          disabled: false,
          href: "/materials",
        },
        {
          text: i18n.t("Nav.campaign"),
          disabled: false,
          href: "/campaign",
        },
      ];
      if (this.mode == "new") {
        item.push({
          text: i18n.t("Campaigns.newInfo"),
          disabled: true,
          href: "/campaign",
        });
      }
      item.push({
        text:
          this.Type == 101
            ? i18n.t("Campaigns.activities.type1")
            : this.Type == 102
            ? i18n.t("Campaigns.activities.type2")
            : this.Type == 103
            ? i18n.t("Campaigns.activities.type3")
            : this.Type == 104
            ? i18n.t("Campaigns.activities.type4")
            : this.Type == 105
            ? i18n.t("Campaigns.activities.type5")
            : this.Type == 106
            ? i18n.t("Campaigns.activities.type6")
            : this.Type == 107
            ? i18n.t("Campaigns.activities.type7")
            : this.Type == 108
            ? i18n.t("Campaigns.activities.type8")
            : this.Type == 109
            ? i18n.t("Campaigns.activities.type9")
            : "",
        disabled: true,
        href: "/campaign",
      });

      return item;
    },
    isNew() {
      return this.mode == "new";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isView() {
      return this.mode == "view";
    },
    Type() {
      return this.$route.query.type;
    },
    districtHeaders() {
      var headers = [
        {
          text: i18n.t("MaterialOrderRule.Fields.district_code"),
          align: "start",
          sortable: false,
          value: "number",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.district_name"),
          align: "start",
          sortable: false,
          value: "name",
        },
      ];
      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },
    shopHeaders() {
      var headers = [
        {
          text: i18n.t("Shop.Fields.shop_code", [this.$consts.shopName()]),
          align: "start",
          sortable: false,
          value: "shop_code",
        },
        {
          text: i18n.t("Shop.Fields.shop_name", [this.$consts.shopName()]),
          align: "start",
          sortable: false,
          value: "shop_name",
        },
      ];
      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },
    categoryHeaders() {
      var headers = [
        {
          text: i18n.t("Campaigns.Fields.categories_name"),
          align: "start",
          sortable: false,
          value: "name",
        },
      ];
      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },
    rulerTypeHeaders() {
      var headers = [
        {
          text: i18n.t("Campaigns.Fields.step"),
          align: "start",
          sortable: false,
          value: "step",
        },
      ];
      if (this.Type == 101) {
        headers.push(
          {
            text: i18n.t("Campaigns.Fields.material_num"),
            align: "end",
            sortable: false,
            value: "material_num",
          },
          {
            text: i18n.t("Campaigns.Fields.present_material"),
            align: "end",
            sortable: false,
            value: "present_material",
          },
          {
            text: i18n.t("Campaigns.Fields.present_num"),
            align: "end",
            sortable: false,
            value: "present_num",
          }
        );
      }
      if (this.Type == "102") {
        headers.push(
          {
            text: i18n.t("Campaigns.Fields.material_num_two"),
            align: "end",
            sortable: false,
            value: "material_num",
          },
          {
            text: i18n.t("Campaigns.Fields.material_price"),
            align: "end",
            sortable: false,
            value: "material_price",
          }
        );
      }
      if (this.Type == "103") {
        headers.push(
          {
            text: i18n.t("Campaigns.Fields.material_num_two"),
            align: "end",
            sortable: false,
            value: "material_num",
          },
          {
            text: i18n.t("Campaigns.Fields.material_cut"),
            align: "end",
            sortable: false,
            value: "material_cut",
          }
        );
      }
      if (this.Type == "104") {
        headers.push(
          {
            text: i18n.t("Campaigns.Fields.order_price"),
            align: "end",
            sortable: false,
            value: "order_price",
          },
          {
            text: i18n.t("Campaigns.Fields.present_material"),
            align: "end",
            sortable: false,
            value: "present_material",
          },
          {
            text: i18n.t("Campaigns.Fields.present_num"),
            align: "end",
            sortable: false,
            value: "present_num",
          }
        );
      }
      if (this.Type == "105") {
        headers.push(
          {
            text: i18n.t("Campaigns.Fields.order_price"),
            align: "end",
            sortable: false,
            value: "order_price",
          },
          {
            text: i18n.t("Campaigns.Fields.price_cut_five"),
            align: "end",
            sortable: false,
            value: "price_cut",
          }
        );
      }
      if (this.Type == "106") {
        headers.push(
          {
            text: i18n.t("Campaigns.Fields.order_price"),
            align: "end",
            sortable: false,
            value: "order_price",
          },
          {
            text: i18n.t("Campaigns.Fields.order_cut"),
            align: "end",
            sortable: false,
            value: "material_cut",
          }
        );
      }
      if (this.Type == "107") {
        headers.push(
          {
            text: i18n.t("Campaigns.Fields.material_price_seven"),
            align: "end",
            sortable: false,
            value: "material_price",
          },
          {
            text: i18n.t("Campaigns.Fields.present_material"),
            align: "end",
            sortable: false,
            value: "present_material",
          },
          {
            text: i18n.t("Campaigns.Fields.present_num"),
            align: "end",
            sortable: false,
            value: "present_num",
          }
        );
      }
      if (this.Type == "108") {
        headers.push(
          {
            text: i18n.t("Campaigns.Fields.material_price_eight"),
            align: "end",
            sortable: false,
            value: "material_price",
          },
          {
            text: i18n.t("Campaigns.Fields.price_cut"),
            align: "end",
            sortable: false,
            value: "price_cut",
          }
        );
      }
      if (this.Type == "109") {
        headers.push(
          {
            text: i18n.t("Campaigns.Fields.material_price_eight"),
            align: "end",
            sortable: false,
            value: "material_price",
          },
          {
            text: i18n.t("Campaigns.Fields.price_cut_nine"),
            align: "end",
            sortable: false,
            value: "material_cut",
          }
        );
      }
      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },
    rulerTypeItems() {
      return this.Type == 101
        ? this.type_one
        : this.Type == 102
        ? this.type_two
        : this.Type == 103
        ? this.type_three
        : this.Type == 104
        ? this.type_four
        : this.Type == 105
        ? this.type_five
        : this.Type == 106
        ? this.type_six
        : this.Type == 107
        ? this.type_seven
        : this.Type == 108
        ? this.type_eight
        : this.Type == 109
        ? this.type_nine
        : [];
    },
    materialItems() {
      return this.materials.map((detail) => {
        detail.Description = i18n.t(
          this.settings
            ? this.settings.material_name_display_type == 4
              ? "Material.nameWithCodeAndStandard"
              : this.settings.material_name_display_type == 3
              ? "Material.materialNameWithCodeAndStandard"
              : this.settings.material_name_display_type == 2
              ? "Material.materialNameWithCode"
              : "Material.materialName"
            : "Material.materialName",
          [detail.material_code, detail.material_name, detail.standard_name]
        );
        return detail;
      });
    },
    materialHeaders() {
      var materialHeaders = [
        {
          text: i18n.t("MaterialOrderRule.Fields.category_name"),
          align: "start",
          sortable: false,
          value: "material_category.name",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "Description",
        },
      ];

      if (this.savable) {
        materialHeaders.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }

      return materialHeaders;
    },
    districtsTypeItems() {
      return Consts.campaign.districts_types;
    },
    materialsTypeItems() {
      return Consts.campaign.materials_types;
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    panels: [0],
    panels_two: [0],
    mode: "",
    campaign: {},
    conditions: {},
    districts_dialog: false,
    districts: [],
    districtsLoading: false,
    ladderFlg: "0",
    loopFlg: 0,
    materials_dialog: false,
    choosedMaterials: [],
    materialIds: [],
    materials: [],
    materialsLoading: false,
    selectMaterialDialog: false,
    type_one: JSON.parse(JSON.stringify(defaultTypeOne)),
    type_two: JSON.parse(JSON.stringify(defaultTypeTwo)),
    type_three: JSON.parse(JSON.stringify(defaultTypeThree)),
    type_seven: JSON.parse(JSON.stringify(defaultTypeSeven)),
    type_eight: JSON.parse(JSON.stringify(defaultTypeEight)),
    type_nine: JSON.parse(JSON.stringify(defaultTypeNine)),
    type_four: JSON.parse(JSON.stringify(defaultTypeFour)),
    type_five: JSON.parse(JSON.stringify(defaultTypefive)),
    type_six: JSON.parse(JSON.stringify(defaultTypesix)),
    selectMaterial: {},
    currentIndex: null,
    submit_data: {},
    district_type: 1,
    shops_dialog: false,
    shops: [],
    material_type: 1,
    category_dialog: false,
    categories: [],
    toEdit: false,
    alertMessage: "",
    newId: null,
    sub_account_type: null,
  }),

  mounted() {
    if (this.$route.params.id == 0) {
      this.mode = "new";
    } else {
      this.mode = this.$route.query.mode ? this.$route.query.mode : "view";
      this.getCampaignsFromAPI(this.$route.params.id);
    }
  },

  methods: {
    getCampaignsFromAPI(id) {
      Campaigns.fetchOne(id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.campaign = response.data.campaign;
            this.conditions = response.data.campaign.conditions;
            this.ladderFlg = response.data.campaign.ladder_flg;
            this.loopFlg = response.data.campaign.loop_flg;

            // 适用分组
            if (
              response.data.campaign.district_list &&
              response.data.campaign.district_list.length
            ) {
              this.districts = response.data.campaign.district_list;
              this.district_type = 2;
            } else if (
              response.data.campaign.shop_list &&
              response.data.campaign.shop_list.length
            ) {
              this.shops = response.data.campaign.shop_list;
              this.district_type = 3;
            } else {
              this.district_type = 1;
            }
            // 适用商品
            if (
              response.data.campaign.conditions.material_list &&
              response.data.campaign.conditions.material_list.length
            ) {
              this.materials = response.data.campaign.conditions.material_list;
              this.material_type = 3;
            } else if (
              response.data.campaign.conditions.categoryCodes &&
              response.data.campaign.conditions.categoryCodes.length &&
              response.data.campaign.conditions.categoryNames &&
              response.data.campaign.conditions.categoryNames.length
            ) {
              this.categories =
                response.data.campaign.conditions.categoryCodes.map(
                  (item, index) => {
                    return {
                      code: item,
                      name: response.data.campaign.conditions.categoryNames[
                        index
                      ],
                    };
                  }
                );
              this.material_type = 2;
            } else {
              this.material_type = 1;
            }

            var ruler = response.data.campaign.conditions.ruler;
            if (this.Type == 101) {
              this.type_one = ruler.material_num.map((item, index) => {
                return {
                  material_num: item,
                  present_num: ruler.present_num[index],
                  present_material: ruler.material_list.find(
                    (present) => present.id == ruler.presentId[index]
                  ),
                };
              });
            } else if (this.Type == 102) {
              this.type_two = ruler.material_num.map((item, index) => {
                return {
                  material_num: item,
                  material_price: ruler.material_price[index],
                };
              });
            } else if (this.Type == 103) {
              this.type_three = ruler.material_num.map((item, index) => {
                return {
                  material_num: item,
                  material_cut: this.$numberFormatter.formatTwoDot(
                    ruler.material_cut[index] * 100,
                    true
                  ),
                };
              });
            } else if (this.Type == 107) {
              this.type_seven = ruler.material_price.map((item, index) => {
                return {
                  material_price: item,
                  present_num: ruler.present_num[index],
                  present_material: ruler.material_list.find(
                    (present) => present.id == ruler.presentId[index]
                  ),
                };
              });
            } else if (this.Type == 108) {
              this.type_eight = ruler.material_price.map((item, index) => {
                return {
                  material_price: item,
                  price_cut: ruler.price_cut[index],
                };
              });
            } else if (this.Type == 109) {
              this.type_nine = ruler.material_price.map((item, index) => {
                return {
                  material_price: item,
                  material_cut: this.$numberFormatter.formatTwoDot(
                    ruler.price_cut[index] * 100,
                    true
                  ),
                };
              });
            } else if (this.Type == 104) {
              this.type_four = ruler.order_price.map((item, index) => {
                return {
                  order_price: item,
                  present_num: ruler.present_num[index],
                  present_material: ruler.material_list.find(
                    (present) => present.id == ruler.presentId[index]
                  ),
                };
              });
            } else if (this.Type == 105) {
              this.type_five = ruler.order_price.map((item, index) => {
                return {
                  order_price: item,
                  price_cut: ruler.price_cut[index],
                };
              });
            } else if (this.Type == 106) {
              //将price_cut换成material_cut,便于使用百分比组件
              this.type_six = ruler.order_price.map((item, index) => {
                return {
                  order_price: item,
                  material_cut: ruler.price_cut[index],
                };
              });
            }
          }
        }.bind(this)
      );
    },
    addExpressDetail() {
      if (this.Type == 101) {
        this.type_one.push({});
      } else if (this.Type == 102) {
        this.type_two.push({});
      } else if (this.Type == 103) {
        this.type_three.push({});
      } else if (this.Type == 107) {
        this.type_seven.push({});
      } else if (this.Type == 108) {
        this.type_eight.push({});
      } else if (this.Type == 104) {
        this.type_four.push({});
      } else if (this.Type == 105) {
        this.type_five.push({});
      } else if (this.Type == 106) {
        this.type_six.push({});
      } else if (this.Type == 109) {
        this.type_nine.push({});
      }
    },
    submit() {
      this.$store.dispatch("fullscreenLoading");
      // this.serverErrors = []; //重置远端错误提示
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            //整理提交数据

            // if (this.Type == 101) {
            //   var material_ids = [];
            //   if (this.materialAs.length) {
            //     material_ids = this.materials.map((material) => {
            //       return material.id;
            //     });
            //   }
            // }
            this.submit_data = {
              type: this.Type,
              name: this.campaign.name,
              description: this.campaign.description,
              date_from: this.campaign.date_from,
              date_to: this.campaign.date_to,
              // districts: districts_code,
              ladder_flg: this.ladderFlg,
            };
            if (this.district_type == 2) {
              var districts_code = this.districts
                ? this.districts.map((district) => {
                    return district.code;
                  })
                : [];
              this.submit_data = Object.assign({}, this.submit_data, {
                districts: districts_code,
              });
            } else if (this.district_type == 3) {
              var shops_id = this.shops
                ? this.shops.map((shop) => {
                    return shop.id;
                  })
                : [];
              this.submit_data = Object.assign({}, this.submit_data, {
                shops: shops_id,
              });
            }
            if (this.Type != 104 && this.Type != 105 && this.Type != 106) {
              if (this.material_type == 2) {
                var category_codes = this.categories
                  ? this.categories.map((category) => {
                      return category.code;
                    })
                  : [];
                this.submit_data = Object.assign({}, this.submit_data, {
                  category_codes: category_codes,
                });
              } else if (this.material_type == 3) {
                var material_ids = this.materials
                  ? this.materials.map((material) => {
                      return material.id;
                    })
                  : [];
                this.submit_data = Object.assign({}, this.submit_data, {
                  material_ids: material_ids,
                });
              }
            }
            if (this.Type == 101) {
              var ruler_materials = [];
              if (this.type_one.length) {
                ruler_materials = this.type_one.map((material) => {
                  return {
                    material_id: material.present_material
                      ? material.present_material.id
                      : "",
                    material_num: material.material_num,
                    present_num: material.present_num,
                  };
                });
              }
              this.submit_data = Object.assign({}, this.submit_data, {
                // material_ids: this.materialIds,
                ruler_materials: ruler_materials,
                loop_flg: this.loopFlg,
              });
            } else if (this.Type == 102) {
              this.submit_data = Object.assign({}, this.submit_data, {
                // material_ids: this.materialIds,
                ruler_materials: this.type_two,
              });
            } else if (this.Type == 103) {
              this.submit_data = Object.assign({}, this.submit_data, {
                // material_ids: this.materialIds,
                ruler_materials: this.type_three,
              });
            } else if (this.Type == 107) {
              var ruler_materials_seven = [];
              if (this.type_seven.length) {
                ruler_materials_seven = this.type_seven.map((material) => {
                  return {
                    material_id: material.present_material
                      ? material.present_material.id
                      : "",
                    material_price: material.material_price,
                    present_num: material.present_num,
                  };
                });
              }
              this.submit_data = Object.assign({}, this.submit_data, {
                // material_ids: this.materialIds,
                ruler_materials: ruler_materials_seven,
                loop_flg: this.loopFlg,
              });
            } else if (this.Type == 108) {
              this.submit_data = Object.assign({}, this.submit_data, {
                // material_ids: this.materialIds,
                ruler_materials: this.type_eight,
                loop_flg: this.loopFlg,
              });
            } else if (this.Type == 109) {
              var ruler_materials_nine = [];
              if (this.type_nine.length) {
                ruler_materials_nine = this.type_nine.map((material) => {
                  return {
                    material_price: material.material_price,
                    price_cut: material.material_cut,
                  };
                });
              }
              this.submit_data = Object.assign({}, this.submit_data, {
                // material_ids: this.materialIds,
                ruler_materials: ruler_materials_nine,
              });
            } else if (this.Type == 104) {
              var ruler_materials_four = [];
              if (this.type_four.length) {
                ruler_materials_four = this.type_four.map((material) => {
                  return {
                    order_price: material.order_price,
                    present_num: material.present_num,
                    material_id: material.present_material
                      ? material.present_material.id
                      : "",
                  };
                });
              }
              this.submit_data = Object.assign({}, this.submit_data, {
                // material_ids: this.materialIds,
                ruler_materials: ruler_materials_four,
              });
            } else if (this.Type == 105) {
              this.submit_data = Object.assign({}, this.submit_data, {
                // material_ids: this.materialIds,
                ruler_materials: this.type_five,
              });
            } else if (this.Type == 106) {
              var ruler_materials_six = [];
              if (this.type_six.length) {
                ruler_materials_six = this.type_six.map((material) => {
                  return {
                    order_price: material.order_price,
                    price_cut: material.material_cut,
                  };
                });
              }
              this.submit_data = Object.assign({}, this.submit_data, {
                // material_ids: this.materialIds,
                ruler_materials: ruler_materials_six,
              });
            }
            if (
              this.settings &&
              this.settings.sub_account_enable == 1 &&
              this.settings.sub_account_split_type == 0 &&
              (this.Type == 102 || this.Type == 108)
            ) {
              this.submit_data = Object.assign({}, this.submit_data, {
                sub_account_type: this.sub_account_type.type,
              });
            }

            //接口提交保存
            if (this.mode == "new") {
              Campaigns.addCampaign(this.submit_data)
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.$snackbar.success(
                        i18n.t("MaterialOrderRule.Messages.saveSuccess")
                      );
                      this.newId = response.data.campaign.id;
                      this.$router.replace("/campaign");
                    }
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
            } else if (this.mode == "edit") {
              Campaigns.editCampaign(
                Object.assign({}, this.submit_data, {
                  id: this.$route.params.id,
                })
              )
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.$snackbar.success(
                        i18n.t("MaterialOrderRule.Messages.saveSuccess")
                      );
                      this.$router.replace("/campaign");
                    }
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
            }
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    selectMaterials() {
      if (this.Type == 101) {
        this.type_one.splice(
          this.currentIndex,
          1,
          Object.assign({}, this.type_one[this.currentIndex], {
            present_material: this.selectMaterial,
          })
        );
      } else if (this.Type == 107) {
        this.type_seven.splice(
          this.currentIndex,
          1,
          Object.assign({}, this.type_seven[this.currentIndex], {
            present_material: this.selectMaterial,
          })
        );
      } else if (this.Type == 104) {
        this.type_four.splice(
          this.currentIndex,
          1,
          Object.assign({}, this.type_four[this.currentIndex], {
            present_material: this.selectMaterial,
          })
        );
      }
    },
    addShop(shops) {
      shops.forEach((shop) => {
        this.shops.push(shop)
      })
    },
  },

  watch: {
    materials: {
      deep: true,
      handler() {
        if (this.materials.length) {
          this.materialIds = this.materials.map((material) => {
            return material.id;
          });
        } else {
          this.materialIds = [];
        }
      },
    },
    // 监听单次选择的商品
    choosedMaterials: {
      handler() {
        //  综合多次选择的商品
        this.choosedMaterials.forEach((material) => {
          this.materials.push(Object.assign({}, material));
        });
      },
    },
    toEdit: {
      handler() {
        if (this.toEdit) {
          this.$router.replace({
            path: this.$route.path,
            query: { type: this.campaign.type, mode: "edit" },
          });
          this.mode = "edit";
        }
      },
    },
    loopFlg: {
      handler() {
        if (this.loopFlg == 1) {
          this.ladderFlg = 0;
        }
      },
    },
    ladderFlg: {
      handler() {
        if (this.ladderFlg == 0) {
          if (this.Type == 101) {
            this.type_one.splice(1);
          } else if (this.Type == 102) {
            this.type_two.splice(1);
          } else if (this.Type == 103) {
            this.type_three.splice(1);
          } else if (this.Type == 107) {
            this.type_seven.splice(1);
          } else if (this.Type == 108) {
            this.type_eight.splice(1);
          } else if (this.Type == 104) {
            this.type_four.splice(1);
          } else if (this.Type == 105) {
            this.type_five.splice(1);
          } else if (this.Type == 106) {
            this.type_six.splice(1);
          } else if (this.Type == 109) {
            this.type_nine.splice(1);
          }
        }
      },
    },
  },
};
</script>